import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from '../../globals';
import { ClientVersionService } from '../client-version/client-version.service';
import { Icon } from './icons.interfaces';

@Injectable({
  providedIn: 'root',
})
/**
 * Icons REST calls
 */
export class IconsService {
  private readonly http = inject(HttpClient);
  private readonly globals = inject(Globals);
  private readonly clientVersionService = inject(ClientVersionService);


  /**
   * Get all icons by functionblock type id
   */
  getIconsByTypeId(typeId: number): Observable<Icon[]> {
    const clientVersion = this.clientVersionService.getVersion();
    const url = `${this.globals.apiRoot}/jwticons/type/${typeId}?clientVersion=${clientVersion}`;
    return this.http.get<Icon[]>(url);
  }

  /**
   * Get all icons by functionblock dynamic type
   */
  getIconsByDynamicType(dynamicType: string): Observable<Icon[]> {
    const clientVersion = this.clientVersionService.getVersion();
    const url = `${this.globals.apiRoot}/jwtIcons/dynamicType/${dynamicType}?clientVersion=${clientVersion}`;
    return this.http.get<Icon[]>(url);
  }
}
